<template lang="pug">
    fragment
        v-layout(row wrap justify-center)
            v-flex(v-if="!isMember" xs12 sm6 lg2)
                widget-component(
                    :content="$t('statistics.widgets.meditations')"
                    :counter="getMinutes(views.total_time)"
                    :showHours="views.total_time > 60000"
                )

                div(v-if="views.longest_practice && views.longest_practice > 6") Longest Practice - {{ (views.longest_practice / 60 ).toFixed() }} minutes

            v-flex(v-if="!isMember" xs12 sm6 lg3)
                widget-component(
                    :content="$t('statistics.widgets.liveMeditations')"
                    :counter="getMinutes(views.total_time_live)"
                    :showHours="views.total_time_live > 60000"
                )

            v-flex(v-if="!isMember" xs12 sm6 lg3)
                widget-component(
                    :content="$t('statistics.widgets.completedMeditations')"
                    :counter="views.total_views"
                )

            v-flex(v-if="!isMember" xs12 sm6 lg2)
                widget-component(
                    :content="$t('statistics.widgets.membersMeditated')"
                    :counter="views.total_users"
                )

            v-flex(v-if="!isMember && uniqueUsers && !id" xs12 sm6 lg2)
                widget-component(
                    :content="$t('statistics.widgets.uniqueUsers')"
                    :counter="uniqueUsers"
                )

        v-layout(row wrap align-center justify-center)
            v-flex(v-if="isMember" xs4 md4)
                progress-widget-component(
                    :completed="totalMinutesGoal"
                    label="Minutes"
                    :totalSteps="500"
                    :goals="[30, 100, 500, 1000, 2000, 3000, 4000, 5000, '50k']"
                )

            v-flex(v-if="isMember" xs4 md4)
                progress-widget-component(
                    :completed="totalWatchesGoal"
                    label="PRACTICES"
                    :totalSteps="30"
                    :goals="[3, 10, 30, 50, 100, 200, 500, 1000, 5000, '10k']"
                )

            v-flex(v-if="isMember" xs4 md4)
                progress-widget-component(
                    :completed="totalDailyViews"
                    label="days streak"
                    :totalSteps="10"
                    :goals="[3, 5, 10, 20, 30, 50, 100, 365, 1000]"
                )

            v-flex(v-if="isMember && challengeIds.includes(user.business_id)" xs12)
                div.activityBadge

                    div.activityBadgeTitle Employee Appreciation Challenge
                    div.activityBadgeText {{`Mindfulness, yoga, stretch, journaling, mindful moments - all count   `}}
                        sub (one per day)
                    div.activityBadgeContent
                        div
                            div.activityBadgeContentLabel Activity
                            div
                                div
                                    span {{ dailyActivityCounter }}
                        div
                            div.activityBadgeContentLabel Duration
                            div
                                div
                                    span {{ challengeInfo.label }}

</template>

<script>
    // TODO: Refactor, create two separate pages for members and other actors
    import VueTypes from 'vue-types';
    import Widget from '~components/Widget';
    import ProgressWidget from '~components/ProgressWidget';
    import { mapGetters } from 'vuex';
    import goals from '~api/goals';
    import statistics from '~api/statistics';
    import dayjs from 'dayjs';
    import Title from '~components/Title';
    import { challengeData } from './challengeData';

    export default {
        components: {
            WidgetComponent: Widget,
            ProgressWidgetComponent: ProgressWidget,
            TitleComponent: Title
        },
        props: {
            period: VueTypes.string.def('lifetime'),
            filters: VueTypes.object.def({
                business: '1',
                department: '2'
            }),
            range: VueTypes.object.def({}),
            id: VueTypes.string.def('')
        },
        data() {
            return {
                goals: null,
                totalMinutes: 0,
                totalMinutesGoal: 0,
                totalWatches: 0,
                totalWatchesGoal: 0,
                dailyActivityCounter: 0,
                daysInMonth: dayjs().daysInMonth(),
                challengeData
            };
        },
        computed: {
            ...mapGetters('auth', [
                'user',
                'isAdmin',
                'isChampion',
                'isMember',
                'isGoldman',
                'isAnthem'
            ]),
            ...mapGetters('statistics', [
                'views',
                'totalDailyViews',
                'counter',
                'uniqueUsers'
            ]),
            challengeIds() {
                return Object.keys(this.challengeData);
            },
            challengeInfo() {
                return this.challengeIds
                    ? this.challengeData[this.user.business_id]
                    : {};
            }
        },
        async mounted() {
            if (this.challengeInfo) {
                const dailyViews = await statistics.dailyActivity(
                    this.challengeInfo.dateFrom,
                    this.challengeInfo.dateTo
                );

                if (dailyViews.ok)
                    this.dailyActivityCounter = dailyViews.data.length;
            }
        },
        async created() {
            if (this.isMember) {
                this.getWidgetsInfo();
            }
        },
        methods: {
            getMinutes(val) {
                const minutes = Math.round(val / 60);

                if (minutes > 1000) return Math.round(minutes / 60);

                return minutes;
            },
            async getWidgetsInfo() {
                let [
                    respGoals,
                    respTotalMinutes,
                    respTotalWatches
                ] = await Promise.all([
                    goals.readUserGoals(),
                    statistics.totalMinutesByGoal(),
                    statistics.totalWatchesByGoal()
                ]);

                if (respTotalMinutes.ok) {
                    this.totalMinutesGoal = Math.round(
                        respTotalMinutes.data.total / 60
                    );
                }
                if (respTotalWatches.ok) {
                    this.totalWatchesGoal = parseInt(
                        respTotalWatches.data.total
                    );
                }

                if (respGoals.ok) {
                    this.goals = respGoals.data;
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_mixins.styl"
    @import "../../../../assets/style/_variables.styl"

    .titleUser
        margin-bottom: 24px
        font-size: remify(20px)
        font-weight: 700

    .activityBadge
        margin: 8px 0
        font-size: 22px
        border-radius: 15px
        padding: 16px
        border: 9px solid rgba(white, 0.2)

    .activityBadgeTitle
        font-size: 28px
        margin-bottom: 15px
        text-align: center

    .activityBadgeText
        font-size: 16px
        text-align: center

    .activityBadgeContent
        display: flex
        align-items: flex-start
        justify-content: space-around
        margin-top: 15px
        text-align: center

        &> div
            text-align: center

        &> div:last-child .activityBadgeContentLabel

            & + div
                font-size: 28px

    .activityBadgeContentLabel
        font-size: 15px
        margin-bottom: 12px
        text-transform: uppercase

        & + div

            font-size: 28px

            font-weight: 300

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .activityBadgeTitle
            font-size: 18px
            margin-bottom: 10px

        .activityBadgeText
            font-size: 14px

        .activityBadgeContent > div:last-child .activityBadgeContentLabel
            margin-bottom: 12px
            & + div
                font-size: 28px

        .activityBadgeContentLabel
            font-size: 10px

            & + div
                font-size: 28px
</style>
